<template>
    <div>
        <v-container fluid>
            <!-- Page Header -->
            <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
                <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
                    <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
                        "Validation Results Dashboard"
                        }}</v-toolbar-title>
                    <v-spacer />
                    <div class="d-flex pr-4">
                        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today
                            }}</v-toolbar-title>
                    </div>
                </v-toolbar>
            </v-skeleton-loader>

            <div class="d-flex align-center justify-end mt-4 mb-4">
                <div class="d-flex ga-2 align-center">
                    <!-- Date Range Filter -->
                    <v-text-field v-model="startDate" label="From" type="date" variant="outlined" density="compact"
                        hide-details style="width: 200px"></v-text-field>
                    <v-text-field v-model="endDate" label="To" type="date" variant="outlined" density="compact"
                        hide-details style="width: 200px"></v-text-field>
                    <v-btn variant="outlined" prepend-icon="mdi-refresh" style="height: 42px;" @click="refreshData"
                        :loading="loading">
                        Refresh
                    </v-btn>
                </div>
            </div>

            <!-- Validation Mode Tabs -->
            <v-card class="mb-4" variant="outlined">
                <v-tabs v-model="selectedValidationMode" color="primary" selected-class="tab-selected">
                    <v-tab value="answer" class="tab-item">Answer Validation</v-tab>
                    <v-tab value="intent" class="tab-item">Intent Validation</v-tab>
                </v-tabs>
            </v-card>

            <!-- Overall Trend Cards -->
            <v-card class="mb-4" variant="outlined">
                <v-card-title class="text-subtitle-1 pa-3 bg-grey-lighten-4 d-flex align-center">
                    <v-icon class="mr-2" size="small">mdi-chart-box-outline</v-icon>
                    Performance Summary
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-row>
                        <!-- Intent Accuracy Card - Hide in "answer" mode -->
                        <v-col cols="12" sm="6" md="3" v-if="selectedValidationMode !== 'answer'">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold"
                                            :class="getTrendColor(overallTrend.accuracy)">
                                            {{ overallTrend.accuracy }}%
                                        </div>
                                        <div class="text-body-2 mt-1">Avg Intent Acc</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                        <!-- <div class="d-flex align-center justify-center mt-1">
                                            <v-icon :color="overallTrend.accuracyChange >= 0 ? 'success' : 'error'"
                                                size="small">
                                                {{ overallTrend.accuracyChange >= 0 ? 'mdi-trending-up' :
                                                'mdi-trending-down' }}
                                            </v-icon>
                                            <span class="text-caption ml-1"
                                                :class="overallTrend.accuracyChange >= 0 ? 'text-success' : 'text-error'">
                                                {{ overallTrend.accuracyChange >= 0 ? '+' : '' }}{{
                                                    overallTrend.accuracyChange
                                                }}% vs prev
                                            </span>
                                        </div> -->
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Intent Accuracy (Routing)</div>
                                    <div>How often the bot routes to the correct intent</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1"> Sum of all Intent Accuracy % / Total job runs within date range</div>
                                        <div class="text-success">(Higher value = Better routing performance)</div>
                                    </div>
                                    <div class="mt-2 text-caption" style="font-family: monospace;">
                                        {{ overallTrend.accuracySum }}% ÷ {{ overallTrend.totalRuns }} runs = {{
                                        overallTrend.accuracy }}%
                                    </div>
                                </div>
                            </v-tooltip>
                        </v-col>
                        <!-- TTFC Card - Always shown -->
                        <v-col cols="12" sm="6" md="3">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold text-info">
                                            {{ overallTrend.avgTTFC }}
                                        </div>
                                        <div class="text-body-2 mt-1">Avg TTFC</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Time to First Chunk (TTFC)</div>
                                    <div>Average response time across all runs</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1">Sum of TTFC values / Runs with TTFC data within date range</div>
                                        <div class="text-warning">(Lower value = Faster response time)</div>
                                    </div>
                                </div>
                            </v-tooltip>
                        </v-col>
                        <!-- Fallback Rate Card - Hide in "answer" mode -->
                        <v-col cols="12" sm="6" md="3" v-if="selectedValidationMode !== 'answer'">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold"
                                            :class="overallTrend.fallbackRate <= 5 ? 'text-success' : 'text-warning'">
                                            {{ overallTrend.fallbackRate }}%
                                        </div>
                                        <div class="text-body-2 mt-1">Avg Fallback Rate</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                        <!-- <div class="text-caption text-grey mt-1">
                                            {{ overallTrend.totalJobs }} unique jobs
                                        </div> -->
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Fallback Rate</div>
                                    <div>How often the bot fails to understand and falls back</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1">Sum of all fallback rates / Total runs within date range</div>
                                        <div class="text-success">(Lower value = Better understanding)</div>
                                    </div>
                                    <!-- <div class="mt-2 text-caption" style="font-family: monospace;">
                                        {{ overallTrend.fallbackSum }}% / {{ overallTrend.totalRuns }} = {{
                                        overallTrend.fallbackRate }}%
                                    </div> -->
                                </div>
                            </v-tooltip>
                        </v-col>
                        <!-- Answer Quality Card - Hide in "intent" mode -->
                        <v-col cols="12" sm="6" md="3" v-if="selectedValidationMode !== 'intent'">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold"
                                            :class="getTrendColor(overallTrend.answerQuality)">
                                            {{ overallTrend.answerQuality }}%
                                        </div>
                                        <div class="text-body-2 mt-1">Avg Answer Quality</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Answer Quality (LLM Judge)</div>
                                    <div>How well the bot's answers match expected responses</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1">Sum of all Answer Quality % / Total runs within date range</div>
                                        <div class="text-success">(Higher value = Better answer accuracy)</div>
                                    </div>
                                </div>
                            </v-tooltip>
                        </v-col>
                        <!-- Guideline Pass Rate Card - Q&A mode only -->
                        <v-col cols="12" sm="6" md="3" v-if="selectedValidationMode === 'answer'">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold"
                                            :class="getTrendColor(overallTrend.guidelinePassRate)">
                                            {{ overallTrend.guidelinePassRate }}%
                                        </div>
                                        <div class="text-body-2 mt-1">Avg Guideline Pass</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Guideline Pass Rate</div>
                                    <div>Answers that follow business rules/guidelines</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1">Sum of Guideline Pass % / Total runs</div>
                                        <div class="text-success">(Higher = Better compliance)</div>
                                    </div>
                                </div>
                            </v-tooltip>
                        </v-col>
                        <!-- Exact Match Rate Card - Q&A mode only -->
                        <v-col cols="12" sm="6" md="3" v-if="selectedValidationMode === 'answer'">
                            <v-tooltip location="bottom">
                                <template #activator="{ props }">
                                    <div class="trend-card text-center pa-3" v-bind="props" style="cursor: pointer;">
                                        <div class="text-h4 font-weight-bold"
                                            :class="getTrendColor(overallTrend.exactPassRate)">
                                            {{ overallTrend.exactPassRate }}%
                                        </div>
                                        <div class="text-body-2 mt-1">Avg Exact Match</div>
                                        <div class="text-caption text-grey mt-1">
                                            Total Runs : {{ overallTrend.totalRuns }}
                                        </div>
                                    </div>
                                </template>
                                <div class="text-center">
                                    <div class="font-weight-bold mb-1">Exact Match Pass Rate</div>
                                    <div>Answers that exactly match expected responses</div>
                                    <div class="mt-2 text-caption">
                                        <div class="mb-1">Sum of Exact Match % / Total runs</div>
                                        <div class="text-success">(Higher = More precise answers)</div>
                                    </div>
                                </div>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <!-- Jobs Table -->
            <v-card variant="outlined">
                <v-card-title class="text-subtitle-1 pa-3 bg-grey-lighten-4 d-flex align-center">
                    <v-icon class="mr-2" size="small">mdi-clipboard-list</v-icon>
                    Test Jobs
                    <v-chip size="small" color="primary" variant="tonal" class="ml-2">
                        {{ filteredJobsByMode.length }} jobs
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="jobSearchQuery" placeholder="Search jobs..." prepend-inner-icon="mdi-magnify"
                        variant="outlined" density="compact" hide-details style="max-width: 250px"
                        clearable></v-text-field>
                </v-card-title>

                <v-data-table :headers="jobTableHeadersForMode" :items="filteredJobsByMode" :items-per-page="10"
                    :search="jobSearchQuery" density="comfortable" class="job-table" hover>
                    <template #item.jobName="{ item }">
                        <div class="d-flex align-center">
                            <v-icon size="small" color="primary" class="mr-2">mdi-clipboard-check</v-icon>
                            <div>
                                <div class="font-weight-medium">{{ item.jobName }}</div>
                            </div>
                        </div>
                    </template>

                    <template #item.totalRuns="{ item }">
                        <v-chip size="small" color="info" variant="tonal">
                            {{ item.totalRuns }} {{ item.totalRuns === 1 ? 'run' : 'runs' }}
                        </v-chip>
                    </template>

                    <template #item.latestAccuracy="{ item }">
                        <v-tooltip location="bottom">
                            <template #activator="{ props }">
                                <div class="d-flex justify-center align-center" v-bind="props">
                                    <v-chip size="small" :color="getAccuracyColor(item.latestAccuracy)" variant="tonal"
                                        class="font-weight-medium">
                                        {{ item.latestAccuracy?.toFixed(1) || '-' }}%
                                    </v-chip>
                                </div>
                            </template>
                            <span>Intent routing accuracy from latest run</span>
                        </v-tooltip>
                    </template>

                    <template #item.latestAnswerQuality="{ item }">
                        <v-tooltip location="bottom">
                            <template #activator="{ props }">
                                <div class="d-flex justify-center align-center" v-bind="props">
                                    <v-chip size="small" :color="getAccuracyColor(item.latestAnswerQuality)" variant="tonal"
                                        class="font-weight-medium">
                                        {{ item.latestAnswerQuality?.toFixed(1) || '-' }}%
                                    </v-chip>
                                </div>
                            </template>
                            <span>Answer quality score from latest run (LLM-as-Judge)</span>
                        </v-tooltip>
                    </template>

                    <template #item.latestGuidelinePassRate="{ item }">
                        <v-tooltip location="bottom">
                            <template #activator="{ props }">
                                <div class="d-flex justify-center align-center" v-bind="props">
                                    <v-chip size="small" :color="getAccuracyColor(item.latestGuidelinePassRate)" variant="tonal"
                                        class="font-weight-medium">
                                        {{ item.latestGuidelinePassRate?.toFixed(1) || '-' }}%
                                    </v-chip>
                                </div>
                            </template>
                            <span>Guideline compliance rate - answers following business rules</span>
                        </v-tooltip>
                    </template>

                    <template #item.latestExactPassRate="{ item }">
                        <v-tooltip location="bottom">
                            <template #activator="{ props }">
                                <div class="d-flex justify-center align-center" v-bind="props">
                                    <v-chip size="small" :color="getAccuracyColor(item.latestExactPassRate)" variant="tonal"
                                        class="font-weight-medium">
                                        {{ item.latestExactPassRate?.toFixed(1) || '-' }}%
                                    </v-chip>
                                </div>
                            </template>
                            <span>Exact match rate - answers exactly matching expected response</span>
                        </v-tooltip>
                    </template>

                    <!-- <template #item.trend="{ item }">
                        <div v-if="item.totalRuns > 1" class="d-flex align-center">
                            <v-icon :color="item.trend >= 0 ? 'success' : 'error'" size="small">
                                {{ item.trend >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}
                            </v-icon>
                            <span class="text-caption ml-1" :class="item.trend >= 0 ? 'text-success' : 'text-error'">
                                {{ item.trend >= 0 ? '+' : '' }}{{ item.trend?.toFixed(1) }}%
                            </span>
                        </div>
                        <span v-else class="text-caption text-grey">-</span>
                    </template> -->

                    <template #item.latestTTFC="{ item }">
                        <span class="text-body-2">{{ formatTTFC(item.latestTTFC) }}</span>
                    </template>

                    <template #item.lastRunAt="{ item }">
                        <div class="text-body-2">{{ formatDateShort(item.lastRunAt) }}</div>
                    </template>

                    <template #item.actions="{ item }">
                        <!-- Q&A Validation mode - dropdown menu -->
                        <v-menu v-if="selectedValidationMode === 'answer'">
                            <template #activator="{ props }">
                                <v-btn size="small" variant="text" color="success" v-bind="props">
                                    <v-icon size="small" class="mr-1">mdi-chart-box-outline</v-icon>
                                    View Details
                                    <v-icon size="small" class="ml-1">mdi-menu-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list density="compact" min-width="150">
                                <v-list-item @click="openJobDetails(item, 'old')">
                                    <template #prepend>
                                        <v-icon size="small">mdi-table-eye</v-icon>
                                    </template>
                                    <v-list-item-title>Card View</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openJobDetails(item, 'new')">
                                    <template #prepend>
                                        <v-icon size="small">mdi-microsoft-excel</v-icon>
                                    </template>
                                    <v-list-item-title>Table View</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        
                        <!-- Intent Validation mode - dropdown menu -->
                        <v-menu v-else>
                            <template #activator="{ props }">
                                <v-btn size="small" variant="text" color="primary" v-bind="props">
                                    <v-icon size="small" class="mr-1">mdi-chart-box-outline</v-icon>
                                    View Details
                                    <v-icon size="small" class="ml-1">mdi-menu-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list density="compact" min-width="150">
                                <v-list-item @click="openJobDetails(item, 'old')">
                                    <template #prepend>
                                        <v-icon size="small">mdi-table-eye</v-icon>
                                    </template>
                                    <v-list-item-title>Card View</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openJobDetails(item, 'new')">
                                    <template #prepend>
                                        <v-icon size="small">mdi-microsoft-excel</v-icon>
                                    </template>
                                    <v-list-item-title>Table View</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'ValidationDashboardV2',
    inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
    data() {
        return {
            today: null,
            loading: false,

            // Validation mode filter
            selectedValidationMode: 'answer', // 'intent', 'answer'

            // Date filters - default to today
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],

            // Job search
            jobSearchQuery: '',

            // All job runs from API
            allJobRuns: [],
        };
    },

    computed: {
        // Group jobs by root job ID (linkedJobId || id) to combine original + reruns
        groupedJobs() {
            const groups = {};
            console.log("allJobRuns:", this.allJobRuns);
            this.allJobRuns.forEach(run => {
                // Group by root job ID: linkedJobId for reruns, id for originals
                const key = run.linkedJobId || run.id;
                if (!groups[key]) {
                    // Extract base job name by stripping "(Rerun #X)" suffix
                    const baseName = (run.jobName || 'Unnamed Job').replace(/ \(Rerun(?: #\d+)?\)$/, '');
                    groups[key] = {
                        rootJobId: key,
                        jobName: baseName,
                        modelId: run.modelId,
                        modelName: run.modelName,
                        validationType: run.validationType || 'intent',
                        runs: [],
                        totalRuns: 0,
                        latestAccuracy: null,
                        latestAnswerQuality: null,
                        latestGuidelinePassRate: null,
                        latestExactPassRate: null,
                        latestTTFC: null,
                        lastRunAt: null,
                        trend: 0,
                        answerTrend: 0,
                    };
                }
                groups[key].runs.push(run);
                groups[key].totalRuns++;
            });

            // Calculate latest stats and trend for each group
            Object.values(groups).forEach(group => {
                // Sort runs by date descending
                group.runs.sort((a, b) => new Date(b.completedAt) - new Date(a.completedAt));

                const latestRun = group.runs[0];
                group.latestAccuracy = latestRun?.accuracy;
                group.latestAnswerQuality = latestRun?.answerQuality;
                group.latestGuidelinePassRate = latestRun?.guidelinePassRate;
                group.latestExactPassRate = latestRun?.exactPassRate;
                group.latestTTFC = latestRun?.avgTTFC;
                group.lastRunAt = latestRun?.completedAt;
                group.modelId = latestRun?.modelId;
                group.modelName = latestRun?.modelName;
                group.validationType = latestRun?.validationType || 'intent';

                // Calculate trends (latest vs previous)
                if (group.runs.length > 1) {
                    const prevRun = group.runs[1];
                    if (latestRun?.accuracy != null && prevRun?.accuracy != null) {
                        group.trend = latestRun.accuracy - prevRun.accuracy;
                    }
                    if (latestRun?.answerQuality != null && prevRun?.answerQuality != null) {
                        group.answerTrend = latestRun.answerQuality - prevRun.answerQuality;
                    }
                }
            });

            return Object.values(groups).sort((a, b) => new Date(b.lastRunAt) - new Date(a.lastRunAt));
        },

        filteredJobsByMode() {
            let jobs = this.filteredGroupedJobs; // Already filtered by date

            if (this.selectedValidationMode === 'answer') {
                // Answer Validation tab: show only 'answer' type (no intent test)
                jobs = jobs.filter(j => j.validationType === 'answer');
            } else {
                // Intent Validation tab: show only 'both' or 'intent' type (has intent test)
                jobs = jobs.filter(j => j.validationType === 'both' || j.validationType === 'intent');
            }

            return jobs;
        },

        jobTableHeadersForMode() {
            const base = [
                { title: 'Job Name', key: 'jobName', width: '220px' },
                { title: 'Model', key: 'modelId', width: '80px' },
                { title: 'Runs', key: 'totalRuns', width: '70px', align: 'center' },
            ];

            // Conditionally add columns based on mode
            if (this.selectedValidationMode !== 'answer') {
                // Intent Validation columns
                base.push({ title: 'Intent Acc%', key: 'latestAccuracy', width: '100px', align: 'center' });
            }

            if (this.selectedValidationMode === 'answer') {
                // Q&A Validation specific columns
                base.push(
                    { title: 'Answer Val%', key: 'latestAnswerQuality', width: '100px', align: 'center' },
                    { title: 'Guideline%', key: 'latestGuidelinePassRate', width: '100px', align: 'center' },
                    { title: 'Exact%', key: 'latestExactPassRate', width: '90px', align: 'center' },
                );
            }

            base.push(
                { title: 'TTFC', key: 'latestTTFC', width: '80px', align: 'center' },
                { title: 'Last Run', key: 'lastRunAt', width: '140px' },
                { title: 'Actions', key: 'actions', width: '100px', align: 'center', sortable: false }
            );

            return base;
        },

        filteredGroupedJobs() {
            const groups = {};
            
            console.log('=== FILTERING DEBUG ===');
            console.log('Date range:', this.startDate, 'to', this.endDate);

            // Filter runs by date range FIRST, then group
            const runsInRange = this.allJobRuns.filter(run => {
                const runDate = run.completedAt?.split('T')[0];
                if (!runDate) return false;
                const inRange = runDate >= this.startDate && runDate <= this.endDate;
                console.log(`Run ${run.jobName} (${runDate}):`, inRange ? '✅ IN RANGE' : '❌ OUT OF RANGE');
                return inRange;
            });

            console.log(`Total runs in range: ${runsInRange.length} out of ${this.allJobRuns.length}`);

            // Now group the filtered runs
            runsInRange.forEach(run => {
                const key = run.linkedJobId || run.id;
                if (!groups[key]) {
                    const baseName = (run.jobName || 'Unnamed Job').replace(/ \(Rerun(?: #\d+)?\)$/, '');
                    groups[key] = {
                        rootJobId: key,
                        jobName: baseName,
                        modelId: run.modelId,
                        modelName: run.modelName,
                        validationType: run.validationType || 'intent',
                        runs: [],
                        totalRuns: 0,
                        latestAccuracy: null,
                        latestAnswerQuality: null,
                        latestGuidelinePassRate: null,
                        latestExactPassRate: null,
                        latestTTFC: null,
                        lastRunAt: null,
                        trend: 0,
                        answerTrend: 0,
                    };
                }
                groups[key].runs.push(run);
                groups[key].totalRuns++;
            });

            // Calculate stats for each group
            Object.values(groups).forEach(group => {
                group.runs.sort((a, b) => new Date(b.completedAt) - new Date(a.completedAt));

                const latestRun = group.runs[0];
                group.latestAccuracy = latestRun?.accuracy;
                group.latestAnswerQuality = latestRun?.answerQuality;
                group.latestGuidelinePassRate = latestRun?.guidelinePassRate;
                group.latestExactPassRate = latestRun?.exactPassRate;
                group.latestTTFC = latestRun?.avgTTFC;
                group.lastRunAt = latestRun?.completedAt;
                group.modelId = latestRun?.modelId;
                group.modelName = latestRun?.modelName;
                group.validationType = latestRun?.validationType || 'intent';

                if (group.runs.length > 1) {
                    const prevRun = group.runs[1];
                    if (latestRun?.accuracy != null && prevRun?.accuracy != null) {
                        group.trend = latestRun.accuracy - prevRun.accuracy;
                    }
                    if (latestRun?.answerQuality != null && prevRun?.answerQuality != null) {
                        group.answerTrend = latestRun.answerQuality - prevRun.answerQuality;
                    }
                }

                console.log(`Job: ${group.jobName}, Type: ${group.validationType}, Runs in range: ${group.totalRuns}`);
            });

            return Object.values(groups).sort((a, b) => new Date(b.lastRunAt) - new Date(a.lastRunAt));
        },

        // Overall trend calculations
        overallTrend() {
            const jobs = this.filteredJobsByMode; // Use mode-filtered jobs
            if (jobs.length === 0) {
                return {
                    accuracy: 0,
                    accuracyChange: 0,
                    avgTTFC: '-',
                    fallbackRate: 0,
                    answerQuality: 0,
                    answerQualityChange: 0,
                    guidelinePassRate: 0,
                    exactPassRate: 0,
                    totalRuns: 0,
                    totalJobs: 0,
                    // For tooltip formulas
                    accuracySum: 0,
                    answerQualitySum: 0,
                    guidelineSum: 0,
                    exactSum: 0,
                    fallbackSum: 0,
                };
            }

            // Get all runs within date range filtered by mode
            let runsInRange = this.allJobRuns.filter(run => {
                const runDate = run.completedAt?.split('T')[0];
                if (!runDate) return false;
                return runDate >= this.startDate && runDate <= this.endDate;
            });

            // Further filter by validation mode
            if (this.selectedValidationMode === 'answer') {
                // Answer tab: only 'answer' type
                runsInRange = runsInRange.filter(r => r.validationType === 'answer');
            } else {
                // Intent tab: only 'both' or 'intent' type
                runsInRange = runsInRange.filter(r => r.validationType === 'both' || r.validationType === 'intent');
            }

            const totalRuns = runsInRange.length;
            const totalJobs = jobs.length;

            // Calculate sums for tooltip display
            const accuracySum = runsInRange.reduce((sum, r) => sum + (r.accuracy || 0), 0);
            const answerQualitySum = runsInRange.reduce((sum, r) => sum + (r.answerQuality || 0), 0);
            const guidelineSum = runsInRange.reduce((sum, r) => sum + (r.guidelinePassRate || 0), 0);
            const exactSum = runsInRange.reduce((sum, r) => sum + (r.exactPassRate || 0), 0);
            const fallbackSum = runsInRange.reduce((sum, r) => sum + (r.fallbackRate || 0), 0);

            // Calculate averages
            const avgAccuracy = runsInRange.length > 0 ? accuracySum / runsInRange.length : 0;

            const ttfcValues = runsInRange.filter(r => r.avgTTFC).map(r => r.avgTTFC);
            const avgTTFC = ttfcValues.length > 0
                ? this.formatTTFC(ttfcValues.reduce((sum, v) => sum + v, 0) / ttfcValues.length)
                : '-';

            const avgFallback = runsInRange.length > 0 ? fallbackSum / runsInRange.length : 0;
            const avgAnswerQuality = runsInRange.length > 0 ? answerQualitySum / runsInRange.length : 0;
            const avgGuideline = runsInRange.length > 0 ? guidelineSum / runsInRange.length : 0;
            const avgExact = runsInRange.length > 0 ? exactSum / runsInRange.length : 0;

            // Calculate change vs previous period (simplified)
            const accuracyChange = jobs.length > 0
                ? jobs.reduce((sum, j) => sum + (j.trend || 0), 0) / jobs.length
                : 0;

            const answerQualityChange = jobs.length > 0
                ? jobs.reduce((sum, j) => sum + (j.answerTrend || 0), 0) / jobs.length
                : 0;

            return {
                accuracy: avgAccuracy.toFixed(1),
                accuracyChange: accuracyChange.toFixed(1),
                avgTTFC,
                fallbackRate: avgFallback.toFixed(1),
                answerQuality: avgAnswerQuality.toFixed(1),
                answerQualityChange: answerQualityChange.toFixed(1),
                guidelinePassRate: avgGuideline.toFixed(1),
                exactPassRate: avgExact.toFixed(1),
                totalRuns,
                totalJobs,
                // For tooltip formulas
                accuracySum: accuracySum.toFixed(1),
                answerQualitySum: answerQualitySum.toFixed(1),
                guidelineSum: guidelineSum.toFixed(1),
                exactSum: exactSum.toFixed(1),
                fallbackSum: fallbackSum.toFixed(1),
            };
        },

    },

    mounted() {
        this.GetDate();
        this.loadJobList();
    },

    methods: {
        GetDate() {
            let today1 = new Date();
            let dd = today1.getDate();
            let mm = today1.getMonth() + 1; //January is 0!

            let yyyy = today1.getFullYear();
            if (dd < 10) {
                dd = "0" + dd;
            }
            if (mm < 10) {
                mm = "0" + mm;
            }

            this.today = dd + "/" + mm + "/" + yyyy;
        },
        // ==================== API CALLS ====================

        async loadJobList() {
            this.loading = true;
            // V2 API: Use GetTableValidationJobs for V2 validation system
            this.$call.GetTableValidationJobs(
                {
                    Status: 'completed',
                    PerPage: 500,
                    SortBy: 'createddate',
                    SortDesc: true,
                },
                (response) => {
                    if (response.status === 0 && response.data) {
                        const items = response.data.data || response.data.items || response.data || [];
                        const realJobs = items.map((job) => ({
                            id: job.id,
                            jobId: job.jobId || job.jobID,
                            jobName: job.jobName || 'Unnamed Job',
                            modelId: job.modelId || null,
                            modelName: job.modelName || null,
                            validationType: job.validationType || 'answer', // V2 defaults to 'answer'
                            completedAt: job.completedAt,
                            accuracy: job.accuracy || job.intentAccuracy || null,
                            avgTTFC: job.avgTTFC || job.averageTTFC || null,
                            fallbackRate: job.fallbackRate || 0,
                            answerQuality: job.answerQuality || job.answerAccuracy || 0,
                            guidelinePassRate: job.guidelinePassRate || 0,
                            exactPassRate: job.exactPassRate || 0,
                            runNumber: job.runNumber || 1,
                            linkedJobId: job.linkedJobId || null,
                        }));

                        this.allJobRuns = realJobs;
                        console.log('Loaded job runs:', this.allJobRuns);
                    }
                    this.loading = false;
                },
                (error) => {
                    console.error('Failed to load job list:', error);
                    this.loading = false;
                }
            );
        },

// ==================== ACTIONS ==

        async refreshData() {
            await this.loadJobList();
        },

        openJobDetails(job, style = 'old') {
            const rootJobId = job.rootJobId || job.runs[0]?.linkedJobId || job.runs[0]?.id;
            
            // Both tabs use the same V2 Validation detail pages
            // style: 'old' = Card View (ValidationJobDetail), 'new' = Table View (ValidationJobDetailV2)
            const routeName = style === 'new' ? 'ValidationJobDetailV2' : 'ValidationJobDetail';
            this.$router.push({
                name: routeName,
                query: { id: rootJobId }
            });
        },

        // ==================== UTILITY ====================

        formatTTFC(ms) {
            if (!ms) return '-';
            return `${(ms / 1000).toFixed(1)}s`;
        },

        formatDateShort(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },

        getAccuracyColor(accuracy) {
            if (accuracy === null || accuracy === undefined) return 'grey';
            if (accuracy >= 90) return 'success';
            if (accuracy >= 70) return 'warning';
            return 'error';
        },

        getTrendColor(value) {
            if (value >= 90) return 'text-success';
            if (value >= 70) return 'text-warning';
            return 'text-error';
        },

    },
};
</script>

<style scoped>
.trend-card {
    background-color: #fafafa;
    border-radius: 8px;
}

.job-table :deep(th) {
    background-color: #f5f5f5 !important;
    font-weight: 600 !important;
}

.tab-item {
    /* border-radius: 8px !important; */
    margin: 0px 0px;
}
.v-tab {
    min-height: 50px !important;
}

.tab-selected {
    background-color: rgb(var(--v-theme-primary)) !important;
    color: white !important;
}
</style>
